module.exports = __webpack_public_path__ + "static/media/stop.eb34600a.svg";